import React from 'react'
import './Fiche.scss'

import { Grid, InputAdornment, Tooltip } from '@material-ui/core'

import DataComponent from 'EurestoComponents/DataComponents'
import Input from 'Components/Input'
import ApiRequest from 'EurestoApi/ApiRequest'

import EurestoDiv from 'EurestoComponents/EurestoDiv'

import Constants from 'EurestoFonction/Constants'
import User from 'EurestoClass/User'

import moment from 'moment'

import Utils from 'EurestoFonction/Utils'
import Data from 'EurestoClass/Data'

import MainForm from 'EurestoComponents/MainForm'
import Traduction from 'Components/Traduction'
import Details2 from '../Details/index'
import Cumuls from '../Cumuls'
import Arborescence from '../Arborescence'
import Stocks from '../Stocks'
import ModeVente from '../ModeVente'
import Switch from 'Components/Switch'
import project from 'EurestoConfig/project.config'
import InformationTiers from '../InformationTiers'
import { browserHistory } from "react-router";

moment.locale('fr')

export default class Index extends React.Component {

    constructor(props) {
        super(props)

        const data = props.data

        let famille
        if (data && data.famille_id) {
            famille = Data.get(Constants.module.GESTION, Constants.donnee.famille, { id: data.famille_id })
        }

        this.state = {
            prixTotal: this.CalculPrixTotal(data.details || []),
            locked_by: data.locked_by,
            locked: props.typeaction === 'update'
                ? (data.locked === 1 && data.locked_by !== User.User.get().id)
                : false,
            disabled: !(props.typeaction === 'update' && data.locked === 1 && data.locked_by === User.User.get().id) && props.typeaction !== 'add',
            TabSelected: (props.type_produit_id === 2 || props.type_produit_id === 5 || data.type_produit_id === 2 || data.type_produit_id === 5) ? 0 : 2,
            produit: {
                gestion_stock: data.gestion_stock || props.type_produit_id === 3 && 1 || 0,
                sortie_reelle_dbm: data.sortie_reelle_dbm || props.type_produit_id === 3 && 1 || 0,
                exclu_demande: data.exclu_demande || 0,
                action: props.typeaction,
                type_produit_id: props.type_produit_id || data.type_produit_id,
                id: data && data.id || undefined,
                media_id: data && data.media_id || undefined,
                media_lien: data && data.media_lien || undefined,
                libelle: data && data.libelle || [],
                abrege: data && data.abrege || [],
                type_tva_id: data && data.type_tva_id || undefined,
                famille_id: famille && famille.famille_id || data && data.famille_id || undefined,
                sfamille_id: famille && famille.famille_id && famille.id || undefined,
                rubrique_id: data && data.rubrique_id || undefined,
                produit_id: data && data.produit_id || undefined,
                progression: data && data.progression || [],
                libelle_part: data && data.libelle_part || [],
                part: data && data.part || '',
                allergenes: data && data.allergenes || [],
                information_tiers: data.information_tiers || {},
            },
            stocks: data && data.stocks && data.stocks.length === 6 && data.stocks,
            details: data && data.details || [],
            modes_ventes: data && data.modes_ventes || [],
            key: {
                stock_datagrid: Utils.getRandomNumber(),
                stock_form: Utils.getRandomNumber(),
                details_datagrid: Utils.getRandomNumber(),
                information_form: Utils.getRandomNumber()
            },
            produits: Data.list(Constants.module.GESTION, Constants.donnee.produit, data && data.id && {
                id: {
                    not: true,
                    value: data.id
                }
            } || {}).map(p => ({
                value: p.id,
                label: p.libelle
            }))
        }
    }

    handleChange = (event, value) => {
        this.setState({
            TabSelected: value,
        })
    }

    onChangeProduit = (data, name) => {
        let produit = {
            ...this.state.produit,
            ...(name === 'picture' && {
                media_id: data.id,
                media_lien: data.media_lien
            } || { [name]: data })
        }
        if (name === 'famille_id') {
            produit = {
                ...produit,
                sfamille_id: undefined
            }
        }

        const key = {
            ...this.state.key,
        }
        if (name === 'produit_id') {
            key.information_form = Utils.getRandomNumber()
        }

        this.setState({
            produit: produit,
            key: key,
        })
    }

    getLibelleTitle = _ => {
        const lib = this.state.produit.libelle.find(l => l.langue_id === (User.User.get().langue_id || l.langue_id === 1))
        return lib && lib.text || ''
    }

    onLock = async () => {
        if (!this.props.doNotLockUnlock) {
            const result = await ApiRequest(project.api + 'gestion', {
                action: 'lock',
                requete: 'produit',
                id: this.state.produit.id
            }, { showAlertError: false })
            if (result && result.code === 1) {
                this.setState({
                    locked: false,
                    disabled: false,
                    locked_by: User.User.get().id,
                    //key_form: Utils.getRandomNumber()
                })
            } else {
                this.setState({
                    locked: true,
                    disabled: true,
                    //key_form: Utils.getRandomNumber()
                }, () => alert('Une personne est déjà en cours de modification de ce produit, vous ne pouvez le modifier'))
            }
        } else {
            this.setState({
                locked: false,
                disabled: false,
                //key_form: Utils.getRandomNumber()
            })
        }
    }


    onCancel = async () => {
        if (this.state.produit.action === 'add') {
            try {
                WL && WL.Execute('ProcFromJS', JSON.stringify({
                    type: 'produit',
                    action: 'cancel',
                    id: this.state.produit.id || undefined
                }))
            } catch (err) {
                if (!(this.props.handleCancel && this.props.handleCancel())) {
                    browserHistory.push({ pathname: '/gestion' })
                }
            }
        } else {
            this.setState({
                locked: false,
                disabled: true,
                //produit: EurestoClone(this.state.produit_save),
                key_form: Utils.getRandomNumber(),
            }, () => {
                ApiRequest(project.api + 'gestion', {
                    action: 'unlock',
                    requete: 'produit',
                    id: this.state.produit.id
                }, { showAlertError: false })
                    .then(result => {
                        if (result && result.code === 1) {
                            try {
                                WL && WL.Execute('ProcFromJS', JSON.stringify({
                                    type: 'produit',
                                    action: 'cancel',
                                    id: this.state.produit.id || undefined
                                }))
                            } catch (err) {
                            }
                        }
                    })
            })
        }
    }

    onSave = (action) => {
        this.setState({
            locked: false,
            disabled: true,
            key_form: Utils.getRandomNumber(),
            produit_update: true
        }, () => this.handleSubmit(action))
    }

    handleSubmit = async (action) => {
        const produit = EurestoClone(this.state.produit)
        produit.critereAutresEtablissements = []
        produit.information_tiers = this.state.produit.information_tiers || {}

        produit.famille_id = produit.sfamille_id || produit.famille_id || undefined

        const { details } = this.state
        if (details.length > 0) produit.details = details.filter(detail => !detail.delete);
        const { stocks } = this.state
        if (stocks.length > 0) produit.stocks = stocks;
        produit.dedupe = this.props.dedupe || []
        if (produit.dedupe.length > 0) {
            const i = produit.dedupe.findIndex(dc => dc === produit.id)
            if (i !== -1) {
                produit.dedupe.splice(i, 1)
            }
        }

        produit.action = action
        produit.requete = 'produit'
        ApiRequest(project.api + 'gestion', produit)
            .then(result => {
                if (result && result.code === 1) {
                    result.libelle = this.state.produit.nom
                    try {
                        WL && WL.Execute('ProcFromJS', JSON.stringify({
                            ...this.state.produit,
                            action: this.state.produit.action,
                            id: this.state.produit.id || result.id,
                            date: result.date_modification
                        }))
                    } catch (err) {
                    }
                    if (this.props.handleAdd !== undefined) {
                        this.props.handleAdd({
                            ...produit,
                            ...result
                        })
                    } else if (this.state.produit.action === 'add') {
                        browserHistory.push({ pathname: '/gestion/' + result.id })
                    }
                } else {
                    this.setState({
                        locked: false,
                        disabled: false,
                        locked_by: User.User.get().id,
                        key_form: Utils.getRandomNumber(),
                    })
                }
            })
    }

    render() {
        return <MainForm key={this.state.key_form + '_form' + this.state.disabled}
            /*disabled={!this.state.disabled}*/
            mainTabProps={{
                style: {
                    padding: '0 65px 0 35px'
                }
            }}
            isAllow={{
                delete: false && !this.props.showInfo && this.state.produit.type !== Constants.access.GROUPE && this.state.produit.type !== Constants.access.ETABLISSEMENT && (!this.state.locked || this.state.locked_by === User.User.get().id),
                update: !this.props.showInfo && !this.state.archive && this.state.TabSelected !== 5 && (!this.state.locked || this.state.locked_by === User.User.get().id),
                add: !this.props.showInfo && !this.state.archive && this.state.produit.action === 'add',
                archive: !this.props.showInfo && !this.state.archive && this.state.TabSelected !== 5 && (!this.state.locked || this.state.locked_by === User.User.get().id),
                unarchive: !this.props.showInfo && this.state.archive && this.state.produit.archive_id,
                cancel: !this.props.doNotLockUnlock
            }}

            libelle={this.getLibelleTitle()}
            action={(this.state.locked || this.state.disabled) && 'view' || this.state.produit.action}
            eurestoBodyStyle={{ padding: 0 }}
            style={{
                padding: 10,
                paddingTop: 0,
                top: ((this.state.locked || this.state.disabled) && 'view' || this.state.produit.action) === 'view' && this.state.TabSelected !== 0 && 19 || 0,
                position: 'relative'
            }}
            onClickUpdate={!this.props.showInfo && !this.state.archive && this.state.TabSelected !== 5 && ((!this.state.locked || this.state.locked_by === User.User.get().id) && this.state.disabled)}
            showTab={(!this.props.forceUpdate === false || this.state.produit.action !== 'add')}
            onSave={this.onSave}
            onUpdate={this.onLock}
            onCancel={this.onCancel}
            onView={this.onCancel}
            libelleAdd={EurestoI18n.t('commun:Nouveau Produit')}
            modalHeight={this.props.modalHeight}
            handleChange={this.handleChange}
            value={this.state.TabSelected}
            tabs={[{
                value: 0,
                allow: (this.state.produit.type_produit_id === 1 || this.state.produit.type_produit_id === 2 || this.state.produit.type_produit_id === 5),
                label: EurestoI18n.t('FT'),
                component: this.OngletDetails
            }, {
                value: 5,
                label: EurestoI18n.t('Autres Critères'),
                allow: true,
                component: this.OngletCriteres
            }, {
                value: 1,
                label: EurestoI18n.t('Progression'),
                allow: (this.state.produit.type_produit_id === 1 || this.state.produit.type_produit_id === 2 || this.state.produit.type_produit_id === 5) && (this.state.details || []).length > 0,
                component: this.OngletProgression
            }, {
                value: 3,
                label: EurestoI18n.t('Arborescence'),
                allow: (this.state.produit.type_produit_id === 1 || this.state.produit.type_produit_id === 2 || this.state.produit.type_produit_id === 5) && (this.state.details || []).length > 0,
                component: this.OngletArborescence
            }, {
                value: 4,
                label: EurestoI18n.t('Cumuls'),
                component: this.OngletCumuls,
                allow: (this.state.produit.type_produit_id === 1 || this.state.produit.type_produit_id === 2 || this.state.produit.type_produit_id === 5) && (this.state.details || []).length > 0,
            }, {
                value: 2,
                label: EurestoI18n.t('Stock'),
                component: this.OngletStock
            }, {
                value: 6,
                allow: (this.state.produit.type_produit_id === 1 || this.state.produit.type_produit_id === 2 || this.state.produit.type_produit_id === 4 || this.state.produit.type_produit_id === 6),
                label: EurestoI18n.t('Vente'),
                component: this.TabInfosVentes
            },]}
            general={this.FicheChildren} />
    }

    FicheChildren = () => {
        return <Grid key={this.state.key_form} direction={'column'} container justify={'flex-start'}
            alignContent={'flex-start'}
            wrap={'nowrap'}
            alignItems={'stretch'}
            style={{
                margin: 0,
                padding: 7.5,
                paddingTop: 0,
                maxHeight: '100%',
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'left'
            }}
            spacing={0}>
            {/*<Tooltip
        title={this.state.produit.entite === 2 && 'Entité' || 'Personne'}>
        <i className={(!this.state.disabled && 'cursor-pointer' || '') + ' fa-2x VisuFiche ' +
        (
          this.state.produit.type_produit_id === 2 && 'ei-crm_morale EurestoPrimary--text'
          || this.state.produit.type_produit_id === 2 && 'ei-crm_physique EurestoSecondary--text'
        )}
           onClick={() => !this.state.disabled && this.onChangeProduit(this.state.produit.entite === 1 && 2 || 1, 'entite')}/>
      </Tooltip>*/}
            {
                <Tooltip disableTouchListener interactive placement="bottom-end" title={
                    <Grid key={this.state.key_produit} container
                        style={{
                            margin: 0,
                            fontSize: 15,
                            zIndex: 2
                        }} spacing={0}
                        justify={'flex-end'}
                        alignItems={'flex-end'} alignContent={'flex-end'} direction={'column'}>
                        <span className={'EurestoSecondary--text'}
                            style={{ color: '#03BD5B' }}><i className={'ei-commun_ajouter'} />{(this.state.produit.date_creation &&
                                moment(this.state.produit.date_creation).format('DD/MM/YY HH:mm:ss') || '')
                                + (this.state.produit.libelle_user_creation && (', ' + this.state.produit.libelle_user_creation) || '')}</span>
                        <span className={'EurestoPrimary--text'}
                            style={{ color: '#1273EB' }}><i
                                className={'ei-commun_modifier'} />{(this.state.produit.date_modification &&
                                    moment(this.state.produit.date_modification).format('DD/MM/YY HH:mm:ss') || '')
                                    + (this.state.produit.libelle_user_modification && (', ' + this.state.produit.libelle_user_modification) || '')}</span>
                        {(User.TypeAccess.get(Constants.access.EURESTO) || User.TypeAccess.get(Constants.access.GROUPE)) && (this.state.locked || this.state.locked_by === User.User.get().id) &&
                            <span className={'EurestoPrimary--text'}
                                style={{ color: '#DC3545' }}>Bloquée le {(this.state.produit.date_locked &&
                                    moment(this.state.produit.date_locked).format('DD/MM/YY HH:mm:ss') || '')
                                    + (this.state.produit.libelle_user_locked && (', ' + this.state.produit.libelle_user_locked) || '')}&nbsp;
                            <i className={'ei-commun_cadena_ouvert cursor-pointer'} onClick={this.forceUnlock} /></span>
                        }
                    </Grid>}>
                    <i style={{
                        borderRadius: 5,
                        fontSize: 20,
                        padding: '5px 8px',
                        border: '1px solid ' + EurestoColor('EurestoPrimary')
                    }}
                        className='EurestoText--text VisuInfo cursor-pointer ei-commun_question EurestoSecondary' />
                </Tooltip>
            }

            <Grid item xs={12} style={{
                margin: 0,
                padding: 0,
                paddingTop: 5,
                position: 'relative'
            }}>
                <Grid container style={{
                    margin: 0,
                    padding: 0,
                    paddingBottom: 10,
                    width: '100%'
                }} spacing={0} justify={'space-between'} alignItems={'center'} alignContent={'center'} wrap={'nowrap'}>
                    <DataComponent onChange={this.onChangeProduit} name='picture'
                        avatarStyle={{
                            borderRadius: 10,
                            maxWidth: 100,
                            maxHeight: 100
                        }} style={{
                            height: 100
                        }} disabled={this.state.disabled} data={{
                            id: this.state.produit.media_id,
                            lien: this.state.produit.media_lien
                        }} type={Constants.typeSaisie.Picture}
                        defineData object={{
                            picture: {
                                id: this.state.produit.media_id,
                                lien: this.state.produit.media_lien
                            },
                            type: 'produit'
                        }} />
                </Grid>
            </Grid>
            <Traduction
                inline
                title={EurestoI18n.t('commun:Nom')}
                onChange={this.onChangeProduit}
                disabled={this.state.disabled}
                name={'libelle'}
                data={this.state.produit.libelle !== undefined ? this.state.produit.libelle : []}
                type={Constants.typeSaisie.SaisieLibre}
            />
            <Traduction
                inline
                title={EurestoI18n.t('commun:Abrégé')}
                onChange={this.onChangeProduit}
                disabled={this.state.disabled}
                name={'abrege'}
                data={this.state.produit.abrege !== undefined ? this.state.produit.abrege : undefined}
                type={Constants.typeSaisie.SaisieLibre}
            />
            <DataComponent
                inline
                title={EurestoI18n.t('gestion:Famille')}
                name="famille_id"
                disabled={this.state.disabled}
                type={Constants.typeSaisie.ComboSimple}
                onChange={this.onChangeProduit}

                data={this.state.produit.famille_id}
                object={Constants.donnee.famille}
                module={Constants.module.GESTION}
                search={{ famille_id: null }}
            />
            {this.state.produit.famille_id && Data.list(Constants.module.GESTION, Constants.donnee.famille, { famille_id: this.state.produit.famille_id }).length > 0 &&
                <DataComponent
                    inline
                    title={EurestoI18n.t('gestion:Sous Famille')}
                    name="sfamille_id"
                    disabled={this.state.disabled}
                    type={Constants.typeSaisie.ComboSimple}
                    onChange={this.onChangeProduit}
                    data={this.state.produit.sfamille_id}
                    object={Constants.donnee.famille}
                    module={Constants.module.GESTION}
                    search={{ famille_id: this.state.produit.famille_id }}
                />
            }
            <DataComponent
                inline
                title={EurestoI18n.t('gestion:Rubrique')}
                name="rubrique_id"
                disabled={this.state.disabled}
                type={Constants.typeSaisie.ComboSimple}
                onChange={this.onChangeProduit}

                data={this.state.produit.rubrique_id}
                object={Constants.donnee.rubrique}
                module={Constants.module.GESTION}
            />
            <DataComponent
                inline
                title={EurestoI18n.t('commun:Allergènes')}
                name="allergenes"
                disabled={this.state.disabled}
                type={Constants.typeSaisie.ComboMulti}
                onChange={this.onChangeProduit}

                data={this.state.produit.allergenes}
                object={Constants.donnee.allergene}
                module={Constants.module.GESTION}
            />
            {(this.state.produit.type_produit_id === 2 || this.state.produit.type_produit_id === 5) && <Input
                onChange={this.onChangeProduit}
                inline
                name="part"
                disabled={this.state.disabled}
                type="number"
                value={this.state.produit.part}
                title={EurestoI18n.t('gestion:Préparation pour')}
            />}
            {(this.state.produit.type_produit_id === 2 || this.state.produit.type_produit_id === 5) && <Traduction
                onChange={this.onChangeProduit}
                inline
                name={'libelle_part'}
                disabled={this.state.disabled}
                data={this.state.produit.libelle_part !== undefined ? this.state.produit.libelle_part : []}
                type={Constants.typeSaisie.SaisieLibre}
                title={''}
            />}

            {(this.state.produit.type_produit_id === 1 || this.state.produit.type_produit_id === 2 || this.state.produit.type_produit_id === 3) && <Switch key={'gestion_stock-' + this.state.produit.gestion_stock}
                name={"gestion_stock"}
                onChange={this.onChangeProduit}
                disabled={this.state.disabled}
                checked={this.state.produit.gestion_stock}
                label={EurestoI18n.t('crm:Géré en stock')} />
            }
            {
                this.state.produit.gestion_stock &&
                <React.Fragment>
                    <Switch key={'exclu_demande-' + this.state.produit.exclu_demande}
                        onChange={this.onChangeProduit}
                        name={"exclu_demande"}
                        disabled={this.state.disabled}
                        checked={this.state.produit.exclu_demande}
                        label={EurestoI18n.t('crm:Exclure des demandes de commande')} />
                    {EurestoOption(Constants.options[Constants.methods.GESTION].DBM.id) && <Switch
                        key={'sortie_reelle_dbm-' + this.state.produit.sortie_reelle_dbm}
                        name={"sortie_reelle_dbm"}
                        onChange={this.onChangeProduit}
                        disabled={this.state.disabled}
                        checked={this.state.produit.sortie_reelle_dbm}
                        label={EurestoI18n.t('crm:Sortie réelle DBM en unité de stockage?')} />}
                    <DataComponent
                        inline
                        title={EurestoI18n.t('commun:Tva')}
                        name="type_tva_id"
                        key={'tva-produit' + this.state.produit.type_tva_id}
                        disabled={this.state.disabled}
                        type={Constants.typeSaisie.AutoComplete}
                        onChange={this.onChangeProduit}
                        data={this.state.produit.type_tva_id}
                        object={Constants.donnee.type_tva}
                        module={Constants.module.GESTION}
                    />
                </React.Fragment> || <div />}
            {
                this.state.prixTotal && <Input value={this.state.prixTotal} key={this.state.prixTotal} disabled title={
                    (this.state.produit.type_produit_id === 2 || this.state.produit.type_produit_id === 5) && EurestoI18n.t('commun:Coût de Revient') ||
                    EurestoI18n.t('commun:Prix PMP')} inline
                    style={{
                        backgroundColor: EurestoColor('EurestoError'),
                        color: 'white',

                    }}
                    inputStyle={{ textAlign: 'right' }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">&nbsp;€</InputAdornment>
                    }} /> || null
            }
        </Grid >
    }



    handleProduitInformationsTiersChange = (data, name) => {
        this.setState({
            produit: {
                ...this.state.produit,
                information_tiers: {
                    ...this.state.produit.information_tiers,
                    [name]: data
                }
            }
        })
    }

    CalculPrixTotal = (details) => Math.round(details.reduce((prix, detail) => prix + (Math.round((detail.quantite || 0) * (detail.prix || 0) * 1000) / 1000), 0) * 1000) / 1000

    OngletProgression = () =>
        <EurestoDiv title={EurestoI18n.t('gestion:Progression')} expandable={true} expanded={true}>
            <Grid container style={{ margin: 0, padding: 0 }} spacing={0}>
                <Grid item style={{ margin: 0, padding: 0 }} xs={12}>
                    <Traduction
                        onChange={this.onChangeProduit}
                        name={'progression'}
                        height={'500px'}
                        disabled={this.state.disabled}
                        data={this.state.produit.progression !== undefined ? this.state.produit.progression : []}
                        type={Constants.typeSaisie.Wysiwyg}
                    />
                </Grid>
            </Grid>
        </EurestoDiv>

    onChange = (data, name) => {
        this.setState({
            ...(this.state || {}),
            [name]: data,
            ...(name === 'details' && { prixTotal: this.CalculPrixTotal(data) } || {})
        })
    }

    OngletCriteres = () => <InformationTiers produit={this.state.produit}
        type_produit_id={this.state.produit.type_produit_id}
        disabled={this.state.disabled}
        onChange={this.handleProduitInformationsTiersChange} />

    OngletDetails = () => <Details2 onChange={this.onChange} name={'details'} produit_id={this.state.produit.id}
        disabled={this.state.disabled} details={this.state.details} />

    OngletStock = () => <Stocks onChange={this.onChange} name={'stocks'}
        disabled={this.state.disabled} stocks={this.state.stocks} />

    OngletArborescence = () => <Arborescence details={this.state.details} />
    OngletCumuls = () => <Cumuls details={this.state.details}
        nb_part_libelle={Utils.getTitleObject(this.state.produit || [], 'libelle_part')}
        quantite={this.state.produit.part} />

    TabUtilisation = () => {
        return <div>En cours de développement - Utilisation</div>
    }

    TabFabrication = () => {
        return <div>En cours de développement - Fabrication</div>
    }

    TabCodeBarre = () => {
        return <div>En cours de développement - Code Barre</div>
    }

    TabPlanning = () => {
        return <div>En cours de développement - Planning</div>
    }

    TabInfosVentes = () => <ModeVente onChange={this.onChange} name={'modes_ventes'}
        disabled={this.state.disabled} stocks={this.state.modes_ventes} />

}


// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Component/Fiche/index.js